module.exports = __webpack_public_path__ + "img/cloud-min.11ee1350.png";